import PropTypes from 'prop-types';
import React from 'react';

import config from '../config';
import TripDefaultSettings1 from './TripDefaultSettings1';
import TripDefaultSettings2 from './TripDefaultSettings2';

/**
 * Wrapper component that renders either TripDefaultSettings1 or TripDefaultSettings2
 * based on the feature flag config.features.useTripDefaultSettings2.
 *
 * Both components share the same public interface.
 */
const TripDefaultSettings = (props) => {
  const Component = config.features.useTripDefaultSettings2
    ? TripDefaultSettings2
    : TripDefaultSettings1;

  return <Component {...props} />;
};

TripDefaultSettings.propTypes = {
  mode: PropTypes.oneOf(['operator', 'trip']),
  hasWritePerm: PropTypes.bool,
  hasUpdateTagCategoriesPerm: PropTypes.bool,
  locationSharingValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onLocationSharingChange: PropTypes.func,
  myTripsDisplayValue: PropTypes.bool,
  onMyTripsDisplayChange: PropTypes.func,
  hasGroupChatValue: PropTypes.bool,
  onHasGroupChatChange: PropTypes.func,
  excludeFromChatValue: PropTypes.bool,
  onExcludeFromChatChange: PropTypes.func,
  disableInternalChatValue: PropTypes.bool,
  onDisableInternalChatChange: PropTypes.func,

  operatorDefaultCategories: PropTypes.array,
  defaultsAssociatedTagCategories: PropTypes.array,
  onSetDefaultsAssociated: PropTypes.func,

  trip: PropTypes.object,
  onTripChange: PropTypes.func,
  clientErrors: PropTypes.object,
  isParentTouched: PropTypes.any,
};

export default TripDefaultSettings;
